// Cal State Long Beach's undergraduate majors (#2739). Read on 2026-10-01
// from CSULB's official 2026-2027 Undergraduate and Graduate Catalog,
// Colleges and Departments (navoid=1406): every bachelor's program each
// department page lists, grouped by its college. catalog.csulb.edu redirects
// to the catalog's Acalog host (csulb.catalog.acalog.com), so the .edu
// address is the cited source. The catalog lists each option as its own
// program line, so each stays an entry (as on the SJSU page). Degree
// abbreviations are the catalog's; two lines it writes as "BS" are shown as
// B.S. Environmental Science and Policy appears under both Liberal Arts and
// Natural Sciences and Mathematics and is listed once, under Liberal Arts.
// The catalog's "Cinematics Arts, B.A." is shown under the department's
// name, Cinematic Arts. Left out: combined bachelor's and master's
// programs, Nursing - Registered Nurse (for nurses already licensed), the
// Psychology online cohort through CPaCE, minors, certificates, credential
// programs and graduate programs.
const majors = {
    "slug": "california-state-university-long-beach",
    "read": "2026-10-01",
    "intro": "Every bachelor's program in CSULB's official 2026-2027 Catalog, grouped by the college that offers it, with the degree it leads to. Options are listed as the catalog lists them; combined bachelor's and master's programs, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of the Arts",
            "source": {
                "label": "CSULB 2026-2027 Catalog, Colleges and Departments",
                "url": "https://catalog.csulb.edu/content.php?catoid=12&navoid=1406"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Art, 3-D Media (Fiber, Metal or Wood) Option",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art, Animation Option",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art, Art Education Option",
                    "degree": "B.A."
                },
                {
                    "name": "Art, Art Photography Option",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art, Ceramics Option",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art, Drawing and Painting Option",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art, Graphic Design Option",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art, Illustration Option",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art, Printmaking Option",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art, Sculpture Option",
                    "degree": "B.F.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.A."
                },
                {
                    "name": "Cinematic Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Dance Science",
                    "degree": "B.S."
                },
                {
                    "name": "Design",
                    "degree": "B.A."
                },
                {
                    "name": "Industrial Design",
                    "degree": "B.S."
                },
                {
                    "name": "Interior Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music, Composition Option",
                    "degree": "B.M."
                },
                {
                    "name": "Music, Music Education: Choral-Vocal Music Option",
                    "degree": "B.M."
                },
                {
                    "name": "Music, Music Education: Instrumental Music Option",
                    "degree": "B.M."
                },
                {
                    "name": "Music, Performance Option",
                    "degree": "B.M."
                },
                {
                    "name": "Acting",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre Arts, Performance: Acting Option",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre Arts, Technical Theatre: Scenery/Costume/Lighting Design Option",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "CSULB 2026-2027 Catalog, Colleges and Departments",
                "url": "https://catalog.csulb.edu/content.php?catoid=12&navoid=1406"
            },
            "majors": [
                {
                    "name": "Business Administration, Accountancy Option",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration, Finance Option",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration, Human Resource Management Option",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration, International Business Option",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration, Management Information Systems Option",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration, Management Option",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration, Marketing Option",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration, Operations and Supply Chain Management Option",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "CSULB 2026-2027 Catalog, Colleges and Departments",
                "url": "https://catalog.csulb.edu/content.php?catoid=12&navoid=1406"
            },
            "majors": [
                {
                    "name": "Liberal Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Hung Family College of Engineering",
            "source": {
                "label": "CSULB 2026-2027 Catalog, Colleges and Departments",
                "url": "https://catalog.csulb.edu/content.php?catoid=12&navoid=1406"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Construction Management",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electronics Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Health and Human Services",
            "source": {
                "label": "CSULB 2026-2027 Catalog, Colleges and Departments",
                "url": "https://catalog.csulb.edu/content.php?catoid=12&navoid=1406"
            },
            "majors": [
                {
                    "name": "Athletic Training",
                    "degree": "B.S."
                },
                {
                    "name": "Child and Family Studies, Child Development Option",
                    "degree": "B.A."
                },
                {
                    "name": "Child and Family Studies, Family Science and Community Services Option",
                    "degree": "B.A."
                },
                {
                    "name": "Consumer Affairs",
                    "degree": "B.A."
                },
                {
                    "name": "Criminology and Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "Fashion Merchandising and Design, Fashion Design Option",
                    "degree": "B.A."
                },
                {
                    "name": "Fashion Merchandising and Design, Fashion Merchandising Option",
                    "degree": "B.A."
                },
                {
                    "name": "Health Care Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Health Care Administration, Healthcare Data Analytics Option",
                    "degree": "B.S."
                },
                {
                    "name": "Health Care Administration, Risk Management and Safety Option",
                    "degree": "B.S."
                },
                {
                    "name": "Hospitality Management",
                    "degree": "B.S."
                },
                {
                    "name": "Kinesiology, Exercise Science Option",
                    "degree": "B.S."
                },
                {
                    "name": "Kinesiology, Fitness Option",
                    "degree": "B.S."
                },
                {
                    "name": "Kinesiology, Physical Education - Teacher Education Option",
                    "degree": "B.A."
                },
                {
                    "name": "Kinesiology, Sport Psychology and Leadership Option",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Nutrition and Food Science, Food Science Option",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition and Food Science, Nutrition Option",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health, Community Health Education Option",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health, Health Advocacy and Policy Option",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health, School Health Education Option",
                    "degree": "B.S."
                },
                {
                    "name": "Recreation",
                    "degree": "B.A."
                },
                {
                    "name": "Recreation Therapy",
                    "degree": "B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.A.S.W."
                },
                {
                    "name": "Speech-Language Pathology",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "CSULB 2026-2027 Catalog, Colleges and Departments",
                "url": "https://catalog.csulb.edu/content.php?catoid=12&navoid=1406"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Sign Language Linguistics and Deaf Cultures",
                    "degree": "B.A."
                },
                {
                    "name": "American Sign Language Linguistics and Deaf Cultures, ASL - English Interpreting Option",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Asian American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Business Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Chicano and Latino Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Chinese Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Comparative World Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Economics, Mathematical Economics and Economic Theory Option",
                    "degree": "B.S."
                },
                {
                    "name": "English, Creative Writing Option",
                    "degree": "B.A."
                },
                {
                    "name": "English, English Education Option",
                    "degree": "B.A."
                },
                {
                    "name": "English, Literature Option",
                    "degree": "B.A."
                },
                {
                    "name": "English, Rhetoric and Composition Option",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science and Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science and Policy",
                    "degree": "B.S."
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French and Francophone Studies, Interdisciplinary Option",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.S."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Human Development",
                    "degree": "B.A."
                },
                {
                    "name": "Italian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Liberal Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics, Teaching English to Speakers of Other Languages (TESOL) Option",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics, Translation Studies Option",
                    "degree": "B.A."
                },
                {
                    "name": "Modern Jewish Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Public Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Natural Sciences and Mathematics",
            "source": {
                "label": "CSULB 2026-2027 Catalog, Colleges and Departments",
                "url": "https://catalog.csulb.edu/content.php?catoid=12&navoid=1406"
            },
            "majors": [
                {
                    "name": "Applied Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology, Biology Education Option",
                    "degree": "B.S."
                },
                {
                    "name": "Biology, Molecular Cell Biology and Physiology Option",
                    "degree": "B.S."
                },
                {
                    "name": "Biology, Zoology, Botany, and Ecology Option",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry, Materials Science",
                    "degree": "B.S."
                },
                {
                    "name": "Earth Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Marine Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics, Applied Mathematics Option",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics, Mathematics Education Option",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Multidisciplinary Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics, Materials Science Option",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
